import React from 'react';
import { InformationModal } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PhoneLink } from 'web-ui-components/lib/actions/links';
import { SubHeading } from 'web-ui-components/lib/typography/headings';
import { Content } from '../../infrastructure/content';
import { Icon } from 'web-ui-components/lib/atoms/iconography';

const HelpModal = ({ toggleHelpModal }) => {
  return (
    <Content>
      {({
        helpModalTitle,
        helpModalContentA,
        helpModalContentB,
        helpModalContentC,
        helpModalContentD,
        helpModalContentE,
        helpModalContactNumber
      }) => (
        <InformationModal
          titleText={
            <SubHeading icon={<Icon iconType="Help" />}>
              <span>{helpModalTitle}</span>
            </SubHeading>
          }
          isOpen={true}
          onClose={toggleHelpModal}
        >
          <StandardBody>
            <p>
              {helpModalContentA}
              <br />
              <PhoneLink phoneNumber={helpModalContentB} />
            </p>
            <p>
              {helpModalContentC}
              <br />
              <PhoneLink phoneNumber={helpModalContactNumber} />
            </p>
            <p>{helpModalContentD}</p>
            <p>{helpModalContentE}</p>
          </StandardBody>
        </InformationModal>
      )}
    </Content>
  );
};
export { HelpModal };
